import { CurriculumType } from '@/util/enum';
import { Select } from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ReportsLocale } from "@/locales/localeid";
import { fmtMsg } from "commonui";
import LabelText from "@/components/label-text/label-text.vue";
import { VersionGroupModule } from '@/modules/versiongroup';
import { VCSLevelModel } from '@/models/title-list-model';

@Component({
	components: {
		Select,
		LabelText,
		Option: Select.Option
	}
})
export default class UnitSelect extends Vue {
	@Prop({ default: false }) isVpcOverview?: boolean;
	@Prop({ default: null }) curriculumType?: CurriculumType.GrapeSEED;
	@Prop({ default: [] }) vcsLevelUnits!: VCSLevelModel[];
	public selectedUnitId: any = 0;
	private versionGroupModule = VersionGroupModule;
	units: VCSLevelModel[] = [];

	get unitText() {
		return fmtMsg(ReportsLocale.ReportUnitText);
	}

	get selectedUnit() {
		return this.vcsLevelUnits.find((v) => v.id === this.selectedUnitId);
	}

	get versionGroups() {
		return this.versionGroupModule.versionGroups;
	};

	get selectedGsVersionId() {
		return this.versionGroupModule.selectedGsVersion;
	}

	get selectedLsVersionId() {
		return this.versionGroupModule.selectedLsVersion;
	}

	@Watch("curriculumType", { immediate: true })
	setUNitsByLicenseType() {
		if (this.isVpcOverview) {
			this.units = this.vcsLevelUnits.filter(unit => unit.curriculumType == this.curriculumType);
		}
	}

	@Watch("versionGroupModule.selectedGsVersion", { immediate: true })
	getSelectedGSVersionGroup() {
		if (this.selectedGsVersionId != "-1") {
			this.units = this.vcsLevelUnits.filter(u => u.curriculumType == CurriculumType.GrapeSEED).
				concat(this.units.filter(u => u.curriculumType == CurriculumType.LittleSEED));
		} else {
			this.units = this.units.filter(u => u.curriculumType != CurriculumType.GrapeSEED);
		}
		this.setUNitsByLicenseType();
	}

	@Watch("versionGroupModule.selectedLsVersion", { immediate: true })
	getSelectedLSVersionGroup() {
		if (this.selectedLsVersionId != "-1") {
			this.units = this.units.filter(u => u.curriculumType == CurriculumType.GrapeSEED)
				.concat(this.vcsLevelUnits.filter(u => u.curriculumType == CurriculumType.LittleSEED));
		} else {
			this.units = this.units.filter(u => u.curriculumType != CurriculumType.LittleSEED);
		}
		this.setUNitsByLicenseType();
	}

	@Watch("units", { immediate: true })
	setUnitId() {
		this.selectedUnitId = this.units.length ? this.units[0].id : null;
		this.$emit("selectedUnit", this.selectedUnit);
	}

	handleUnitChange(value) {
		this.selectedUnitId = value;
		this.$emit("selectedUnit", this.selectedUnit);
	}
}
